import React, { useEffect, useState } from "react";
import Hamburger from "./hamburger";
import { siteSettings } from "@/settings/site-settings";
import HeaderMenu from "./header-menu";
import Logo from "../ui/logo";
import { useUI } from "@/contexts/ui.context";
const { site_header } = siteSettings;
import { m } from "framer-motion";
import Link from "next/link";
import { useRouter } from "next/router";
const Header = () => {
  const router = useRouter();

  const { isMenuOpen, setIsMenuOpen } = useUI();
  const [showAnimation, setShowAnimation] = useState(true);
  useEffect(() => {
    if (router?.pathname !== "/") {
      // setLoader(false);
      setShowAnimation(false);
    } else {
      // if (!loader) {
        setShowAnimation(false);
      // }
    }
  }, [router?.pathname]);
  return (
    <m.header
      key={router.pathname}
      initial={{ y: -78, opacity: 0 }}
      animate={{ y: 0 , opacity: 100}}
      // animate={{ y: !loader ? 0 : -78, opacity: !loader ? 100 : 0 }}
      transition={{
        duration: 1,
        delay: showAnimation ? 1.2 : 0.5,
        // delay: !loader && showAnimation ? 1.2 : 0.5,
      }}
      viewport={{ once: true }}
      className={`${
        router?.pathname === "/media" ||
        router?.pathname.startsWith("/job-openings") ||
        router?.pathname === "/contact-us"        
          ? "border-darkGrey"
          : "border-white"
      } ${router?.pathname === "/thankyou" ? "dark-header": ""} z-20 h-[78px] border-b-[0.25px] w-full group/header flex items-center justify-between md:px-8 px-4 absolute top-0 left-0`}
    >
      <Logo />

      <div className="lg:flex hidden items-center w-fit gap-12 h-full">
        <HeaderMenu data={site_header.menu} />
        <Link
          href="/contact-us"
          className="rounded-full bg-beige md:w-[155px] md:h-[55px] w-[120px] h-[40px] flex items-center justify-center hover:bg-white hover:text-darkGrey transition-all duration-300 ease text-darkGrey"
        >
          <span className="text-center leading-none capitalize lg:text-base text-sm font-havletica font-light">
            get in touch
          </span>
        </Link>
      </div>
      <Hamburger />
    </m.header>
  );
};

export default Header;
